module.exports = {"samePdp":{"title":"Want Updates if This Item Goes on Sale?","cta":"Yes, Send Updates","closeCta":"No, Thank You"},"auto":{"title":"Get Updates if This Item Goes on Sale","cta":"Yes, Get Updates","closeCta":"No, Thank You"}}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/MultiplePdpVisitsModal/MultiplePdpVisitsModalCopy.json
// module id = 4193
// module chunks = 62